var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"tw-sticky tw-top-0 tw-z-50 tw-flex tw-w-full tw-flex-none tw-border-b tw-bg-white tw-px-4 tw-py-2.5 tw-text-center tw-font-circular dark:tw-border-gray-700 dark:tw-bg-slate-900"},[_c(_setup.FrkLogo,{staticClass:"tw-mx-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }